import React, { useState } from "react";

import Logo from "../../assets/logos/banner.png";
import {
  FloatingBackButton,
  PageBackground,
  LogoBannerImage,
} from "globalComponents";
import { useHistory } from "react-router-dom";
import axios from "axios";
import {
  Container,
  Title,
  SuccessMessage,
  SubmitButton,
  ButtonContent,
  Label,
  Input,
  Textarea,
  StyledForm,
} from "globalComponents/FormComponents";

const Contact = () => {
  const history = useHistory();
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .post("/contact", {
        subject: `Contact Form Submission from ${form.name}`,
        text: `Name: ${form.name}\nEmail: ${form.email}\nMessage:\n${form.message}`,
        email: form.email,
      })
      .catch((err) => {
        // Optionally handle error (e.g., show error message)
      });
    // Here you would typically send the form data to your backend
    setSubmitted(true);
  };

  return (
    <PageBackground>
      <FloatingBackButton onClick={() => history.goBack()}>
        Back
      </FloatingBackButton>
      <LogoBannerImage src={Logo} alt="Logo" />
      <Container>
        <Title>Contact Us</Title>
        {submitted ? (
          <SuccessMessage>
            <p>
              <span role="img" aria-label="check" style={{ fontSize: 32 }}>
                ✅
              </span>
            </p>
            <p>
              Thank you for contacting us!
              <br />
              We'll get back to you soon.
            </p>
            <SubmitButton onClick={() => history.goBack()}>
              <ButtonContent>← Back</ButtonContent>
            </SubmitButton>
          </SuccessMessage>
        ) : (
          <StyledForm onSubmit={handleSubmit}>
            <div>
              <Label>
                Name
                <Input
                  type="text"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  required
                  placeholder="Your name"
                />
              </Label>
            </div>
            <div>
              <Label>
                Email
                <Input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  required
                  placeholder="you@email.com"
                />
              </Label>
            </div>
            <div>
              <Label>
                Message
                <Textarea
                  name="message"
                  value={form.message}
                  onChange={handleChange}
                  required
                  rows={5}
                  placeholder="How can we help you?"
                />
              </Label>
            </div>
            <SubmitButton type="submit">
              <ButtonContent>
                <svg
                  width="22"
                  height="22"
                  fill="none"
                  viewBox="0 0 24 24"
                  style={{ verticalAlign: "middle" }}
                >
                  <path d="M2 21l21-9-21-9v7l15 2-15 2v7z" fill="#fff" />
                </svg>
                Send Message
              </ButtonContent>
            </SubmitButton>
          </StyledForm>
        )}
      </Container>
    </PageBackground>
  );
};

export default Contact;
